import { useContext } from "react"
import { CoresAplicativoContext } from "./CoresAplicativoContext"

export function useCoresAplicativoContext() {
    return useContext(CoresAplicativoContext)
}
